import "./Footer.css";

const Footer = () => {
  const footerStyle = {
    marginTop: "40px",
    padding: "15px 10px",
    textAlign: "center",
    fontSize: "14px",
    color: "#6c757d",       // soft gray
    borderTop: "1px solid #eaeaea",
    backgroundColor: "#ffffff",
  };

  return (
    <footer style={footerStyle}>
      Developed by: Bangladesh Technical Education Board
    </footer>
  );
};

export default Footer;

